import React from "react";
import cn from "classnames";
import { LoaderPage } from "../../LoaderPage";
import { Button } from "../Button/Button";

export function QueryError({ message, onRetry, className }) {
  return (
    <div className={cn("query-state-error", className)} role="alert">
      <p>{message}</p>
      {onRetry ? (
        <Button text="Retry" onClick={onRetry} size="middle" />
      ) : null}
    </div>
  );
}

export function QueryState({
  isPending,
  isError,
  errorMessage = "Something went wrong. Please try again.",
  onRetry,
  children,
}) {
  if (isPending) {
    return <LoaderPage />;
  }

  if (isError) {
    return (
      <QueryError message={errorMessage} onRetry={onRetry} />
    );
  }

  return children;
}
